module.exports = __webpack_public_path__ + "3d5bbb7379d869cabf63b3089f8343e7.svg";